import Vue from 'vue';
import NoticeDialog from '@/components/notice_dialog.vue';
import loading from '@/components/loading.vue';

// 定义弹窗组件的映射
const dialogComponents = {
  notice: NoticeDialog,
  loading: loading
};

// 存储每个弹窗实例
const instances = {};

// 获取或创建实例
function getInstance(dialogType) {
  if (!instances[dialogType]) {
    const DialogConstructor = Vue.extend(dialogComponents[dialogType]);
    const instance = new DialogConstructor();
    document.body.appendChild(instance.$mount().$el);
    instances[dialogType] = instance;
  }
  return instances[dialogType];
}

// 弹窗调用方法
function showDialog(dialogType, options) {
  const instance = getInstance(dialogType);
  return instance.open(options);
}

// 导出管理器
export default {
  notice(options) {
    return showDialog('notice', options);
  },
  loading: {
    show(message = '加载中~') {
      const instance = getInstance('loading');
      instance.show(message); // 调用 LoadingDialog 的 show 方法
    },
    hide() {
      const instance = getInstance('loading');
      instance.hide(); // 调用 LoadingDialog 的 hide 方法
    },
  },
};



// WEBPACK FOOTER //
// ./src/utils/dialog.js